import { render, staticRenderFns } from "./NameChangeStatus.vue?vue&type=template&id=027b97d7&scoped=true&"
import script from "./NameChangeStatus.vue?vue&type=script&lang=js&"
export * from "./NameChangeStatus.vue?vue&type=script&lang=js&"
import style0 from "./NameChangeStatus.vue?vue&type=style&index=0&id=027b97d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027b97d7",
  null
  
)

export default component.exports